import axios from "axios";
import {gatewayUrl} from "./config";
import {getIdToken, tokenLogin} from "../../../utilities/src/lib/service";
import {eventBus} from "../../../utilities/src";
import {AndroidAction, hasNotify, notifyAndroid} from "./AndroidBridge";
import {tokenUtility} from "../../../data-access/src";

const axiosInstance = axios.create({
  baseURL: gatewayUrl,
  timeout: 30000,
});

axiosInstance.interceptors.request.use(
  (config: any) => {
    return new Promise((resolve, reject) => {
      const oldToken = getIdToken();
      if (hasNotify() && tokenUtility().isTokenExpired(oldToken)) {
        let timeOut: null | NodeJS.Timeout = null;
        eventBus.on(AndroidAction.AUTH_TOKEN_REQUEST, (rawPayload) => {
          clearTimeout(timeOut!);
          const payload = JSON.parse(String(rawPayload));
          tokenLogin(payload.data.token);
          config.headers.Authorization = `Bearer ${payload.data.token}`;
          eventBus.remove(AndroidAction.AUTH_TOKEN_REQUEST);
          resolve(config);
        });
        notifyAndroid("AUTH_TOKEN_REQUEST", {});
        timeOut = setTimeout(() => {
          reject("Fetching new token timed out!");
        }, 50000);
      } else {
        config.headers.Authorization = `Bearer ${oldToken}`;
        resolve(config);
      }
    });
  },
  (error) => Promise.reject(error),
);

export default axiosInstance;
